const messages = {
  title: "Hooldustööd!",
  description:
    'Serveritel tehakse praegu vajalikke hooldustöid.<br/><br/>Seetõttu ei ole teil praegu juurdepääsu teenusele <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Palume teie kannatlikkust ja täname mõistmise eest.<br/><br/> Teie Bridgestone\'i meeskond',
}
export default {
  messages
}
